<div class="modal-header">
  <h5 class="modal-title d-flex gap-2 align-items-center">
    <i class="fal fa-key"></i>
    <ng-container i18n>Change Password</ng-container>
    <app-page-help articleId="b8bkyja7dx" videoId="-"></app-page-help>
  </h5>
  <button (click)="close()" type="button" class="close">
    <i class="far fa-times"></i>
  </button>
</div>
<div class="modal-body">
  <form [formGroup]="form">
    <mat-form-field2 class="mat-block">
      <input
        matInput
        i18n-placeholder
        placeholder="New password:(minimum length of 8 characters)"
        formControlName="password1"
        type="password"
      />
      <mat-error *ngIf="form.get('password1').hasError('required')" i18n>Password is required</mat-error>
      <mat-error *ngIf="form.get('password1').hasError('minNumber')">
        <ng-container i18n>Password must be at least 8 characters long</ng-container>
      </mat-error>
      <mat-error *ngIf="form.get('password1').hasError('maxNumber')" i18n>
        Password must be at most 32 characters long
      </mat-error>
      <mat-error *ngIf="form.get('password1').hasError('pattern')" i18n>Password must not contain spaces</mat-error>
    </mat-form-field2>

    <mat-form-field2 class="mat-block">
      <input matInput i18n-placeholder placeholder="Repeat password" formControlName="password2" type="password" />
      <mat-error *ngIf="form.get('password2').hasError('required')" i18n> Password is required </mat-error>
      <mat-error *ngIf="form.get('password2').hasError('minlength')">
        <ng-container i18n>Password must be at least 8 characters long</ng-container>
      </mat-error>
      <mat-error *ngIf="form.get('password2').hasError('maxlength')" i18n>
        Password must be at most 32 characters long
      </mat-error>
      <mat-error *ngIf="form.get('password2').hasError('pattern')" i18n>Password must not contain spaces</mat-error>
      <mat-error *ngIf="form.get('password2').errors?.passwordMatch" i18n>Passwords do not match</mat-error>
    </mat-form-field2>
  </form>
</div>
<div class="modal-footer">
  <button (click)="close()" type="button" class="btn btn-light">
    <i class="far fa-times"></i> <ng-container i18n>Cancel</ng-container>
  </button>
  <button (click)="save(form)" type="button" class="btn btn-secondary-info create-btn">
    <i class="cs-icon cs-icon-save"></i> <ng-container i18n>save</ng-container>
  </button>
</div>
